
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/renters-insurance",
      function () {
        return require("private-next-pages/renters-insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/renters-insurance"])
      });
    }
  